import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useGlobalStore } from '../../../store/global';
import { useModalStore } from '../../../store/modal';
import { getCsfrToken } from '../../../utils';
export default function AskForAProduct({ title }) {
    const texts = useGlobalStore((state) => state.config.texts);
    const [isChecked, setIsChecked] = React.useState(false);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const close = useModalStore((state) => state.close);
    const api = useGlobalStore((state) => state.config.api);
    async function handleSend(e) {
        e.preventDefault();
        setIsSubmitted(true);
        const { email, message } = Object.fromEntries(new FormData(e.target));
        try {
            const response = await fetch(api.product.check_availability, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getCsfrToken(),
                },
                body: JSON.stringify({
                    email,
                    message,
                    product_url: window.location.href,
                }),
            });
            if (!response.ok) {
                throw new Error('Something went wrong');
            }
        }
        catch (err) {
            console.error(err);
        }
        finally {
            close();
        }
    }
    return (_jsxs("form", { onSubmit: handleSend, className: "ask d-flex flex-column", children: [_jsx("span", { className: "subtitle", children: title }), _jsx("label", { className: "mt-4", children: texts['text35'] }), _jsx("input", { name: "email", className: "ask-input ", type: "email" }), _jsx("label", { className: "mt-2", children: texts['text101'] }), _jsx("textarea", { name: "message", className: "ask-area", rows: 4, cols: 50 }), _jsxs("div", { className: "conditons mr-2 d-flex flex-wrap align-items-center mt-2", children: [_jsx("input", { id: "condition-checkbox", type: "checkbox", checked: isChecked, onChange: (e) => setIsChecked(e.target.checked) }), _jsxs("label", { htmlFor: "condition-checkbox", children: [texts['text264'], "\u00A0", _jsx("a", { href: texts['text391'], target: "_blank", children: texts['text265'] }), ",\u00A0", _jsx("a", { href: texts['text392'], target: "_blank", children: texts['text436'] })] })] }), _jsx("button", { type: "submit", className: "primary mt-2", disabled: !isChecked || isSubmitted, children: texts['text185'] })] }));
}
